"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketService = void 0;
const routes_1 = require("./routes");
class TicketService {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async getOneById(id) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + id);
        return result.data;
    }
    async getOneByIdV2(id) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + id);
        return result;
    }
    async cancel(id) {
        const result = await this.axiosInstance.patch(routes_1.cancelTicketRoute + id + '/cancel');
        return result.data;
    }
    async getLastThree(id, position) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + 'lastThree/' + id + '/' + position);
        return result.data;
    }
    async getLastValidated(id) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + 'lastValidated/' + id);
        return result;
    }
    async getAverage(id) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + 'averageTime/' + id);
        return result;
    }
    async getByQueueAndPosition(id, position) {
        const result = await this.axiosInstance.get(routes_1.getTicketRoute + 'byQueuePosition/' + id + '/' + position);
        return result.data;
    }
}
exports.TicketService = TicketService;
//# sourceMappingURL=index.js.map